/**
 * Shared constants for Square Game polling and timing.
 */

// How often clients re-fetch the square grid to surface new holds/purchases
// made by other users. Applies to both passive pages (homepage) and the
// active purchase page. Keep in sync across consumers.
export const SQUARE_GRID_POLL_MS = 20000;

// Maximum exponential-backoff delay when the grid endpoint fails repeatedly.
export const SQUARE_GRID_POLL_MAX_MS = 60000;
